import { createFileRoute } from '@tanstack/react-router'

import { parseMemorySearch } from '@/components/memory/memory-search-schema'
import { MemoryWorkspace } from '@/components/memory/memory-workspace'

export const Route = createFileRoute('/_app/memoire')({
  validateSearch: parseMemorySearch,
  component: MemoryPage,
})

function MemoryPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <MemoryWorkspace
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: (current) => ({ ...current, ...next }) })
      }}
    />
  )
}
